import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { Fade } from "@mui/material";
import {
  StyledTextField,
  StyledFormButton,
  StyledFormContainer,
} from "../../utils/formStyles";
import osiLogo from "../../utils/images/OSI-LOGO.png";

export function LoginComponent({
  onClickLogin,
}: {
  onClickLogin: (username: string, pass: string) => void;
}) {
  const [username, setUsername] = useState("");
  const [pass, setPass] = useState("");
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onClickLogin(username, pass);
  };

  const handleMicrosoftLogin = () => {
    // Prefer REACT_APP_DEV_API, fallback to REACT_APP_API_URL, then /api
    const apiUrl =
      process.env.REACT_APP_DEV_API || process.env.REACT_APP_API_URL || "/api";
    window.location.href = `${apiUrl}/auth/microsoft`;
  };

  return (
    <Fade in timeout={800}>
      <StyledFormContainer
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "32px",
          borderRadius: "20px",
          maxWidth: 450,
          margin: "auto",
          boxShadow: "0 8px 32px rgba(90, 100, 119, 0.12)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
        }}
      >
        <Box
          sx={{
            m: 2,
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(90, 100, 119, 0.3)",
            borderRadius: 2,
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(10px)",
          }}
        >
          <img
            src={osiLogo}
            alt="OSI Logo"
            style={{
              width: "70px",
              height: "auto",
              objectFit: "contain",
              filter: "brightness(1.1)",
            }}
          />
        </Box>
        <Typography
          component="h1"
          variant="h4"
          sx={{
            color: "primary.main",
            fontWeight: 600,
            marginBottom: 3,
          }}
        >
          Sign in
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: 1, width: "100%" }}
        >
          <StyledTextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Username"
            name="email"
            autoComplete="email"
            value={username}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setUsername(event.target.value)
            }
            sx={{ mb: 2 }}
          />
          <StyledTextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={pass}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setPass(event.target.value)
            }
            sx={{ mb: 3 }}
          />
          <StyledFormButton
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2, mb: 2, py: 1.5 }}
          >
            Sign In
          </StyledFormButton>

          <Button
            fullWidth
            variant="outlined"
            color="primary"
            sx={{
              mt: 1,
              mb: 2,
              py: 1.5,
              textTransform: "none",
              fontWeight: 600,
            }}
            startIcon={
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="24" height="24" rx="4" fill="#F3F3F3" />
                <path d="M5.5 5.5H11.5V11.5H5.5V5.5Z" fill="#F35325" />
                <path d="M12.5 5.5H18.5V11.5H12.5V5.5Z" fill="#81BC06" />
                <path d="M5.5 12.5H11.5V18.5H5.5V12.5Z" fill="#05A6F0" />
                <path d="M12.5 12.5H18.5V18.5H12.5V12.5Z" fill="#FFBA08" />
              </svg>
            }
            onClick={handleMicrosoftLogin}
          >
            Sign in with Microsoft
          </Button>
        </Box>
      </StyledFormContainer>
    </Fade>
  );
}
